export interface IDataVertical {
    /**
     * The vertical unique key
     */
    key: string;
    /**
     * The vertical tab name
     */
    name: string;
    /**
     * The vertical tab value
     */
    value: string;
}
